import C from '../../../constants';

export const setApplicationKey = (key) => ({
    type: C.SET_APPLICATION_KEY,
    payload: key
});

export const incrementApplicationKey = () => ({
    type: C.INCREMENT_APPLICATION_KEY,
});

export const decrementApplicationKey = () => ({
    type: C.DECREMENT_APPLICATION_KEY,
});

export const setShowAddHistory = (show) => ({
    type: C.SET_APPLICATION_SHOW_ADD_HISTORY,
    payload: show
});


// WEBPACK FOOTER //
// ./src/containers/tenant/actions/appDisplay.js